<template>
    <div class="expert-info" v-for="expert in props.ourExperts" :key="expert.id">
        <div>
            <img :src="getImageFileName(expert.id)" alt="DeltaGPT" class="expert-image" />
        </div>
        <div class="expert-text">
            <h2>
                {{ expert.name }}
            </h2>
            <div>
                {{`Research Manager, ${expert.subscription} Service`}}
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { IExpert } from '@/interfaces/deltaGpt/IExpert.ts';

const props = defineProps<{ ourExperts: Array<IExpert>}>();

function getImageFileName (expertName: string) : string {
    return `/images/team/${expertName}.jpg`;
}

</script>

<style lang="scss" scoped>
.expert-info {
    display: flex;
    gap: var(--largeSpacing);
    .expert-image {
        display: block;
        margin-left: auto;
        margin-right: auto;
        width: 80px;
    }
    .expert-text {
        font-size: var(--smallFontSize);
        display: flex;
        flex-direction: column;
        gap: var(--smallSpacing);
    }
}

</style>
